import { Trait } from "../types/nft";

export const calculatePossibilites = (trait: Trait) => {
  const ranges: { [ range: number ]: number } = {};
  for (const val of trait.values) {
    if (!Boolean(ranges[ val.possibility ])) {
      ranges[ val.possibility ] = 1;
    }
    else {
      ranges[ val.possibility ]++;
    }

  }

  const result: { [ range: number ]: string } = {};

  for (const range in ranges) {
    let p = trait.possibility / 100;
    const rangePossibility = parseInt(range) / ranges[ range ];
    p = p * rangePossibility;
    result[ range ] = p.toFixed(2);
  }
  return result;
}


